(() => {
  const symbols = {CAD:'CA$',AUD:'A$',SGD:'S$',HKD:'HK$',USD:'$',AED:'AED',ILS:'₪'};
  function refresh() {
    document.querySelectorAll('[data-curling-price]').forEach(node => {
      const amount = Number(node.dataset.curlingPrice) / 100;
      const currency = node.dataset.curlingPriceCurrency;
      if (!Number.isFinite(amount) || !currency) return;
      try {
        const formatter = new Intl.NumberFormat(document.documentElement.lang || 'fr', {style:'currency',currency});
        const text = formatter.formatToParts(amount).map(part => part.type === 'currency' && symbols[currency] ? symbols[currency] : part.value).join('');
        if (node.textContent !== text) node.textContent = text;
      } catch {}
    });
  }
  let pending = false;
  const schedule = () => { if (pending) return; pending = true; requestAnimationFrame(() => { pending = false; refresh(); }); };
  new MutationObserver(schedule).observe(document.documentElement, {childList:true,subtree:true,attributes:true,attributeFilter:['data-curling-price','data-curling-price-currency']});
  document.addEventListener('DOMContentLoaded',refresh,{once:true});
  refresh();
})();